import isWebView from './isWebView.js';
import { isMobile } from './mobile.js';

const isMobileDeviceOrApp = () => isMobile() || isWebView();

export default isMobileDeviceOrApp;
